<template>
<div>
  <div class="home_page">
    <Breadcrumb :pageTitle="pageTitle" />
  </div>
  <div class="main">
    <div>
      <!-- // 状态(20 待确认、30 待付款、40 付款中、50 已付款) -->
      <div class="tablist">
        <div :class="{'zhuangtaiclick' : number==='all'}"
             class="zhuangtai"
             @click="changeStatus('all') ">全部</div>
        <div class="zhuangtai"
             :class="{'zhuangtaiclick' : number==='20'}"
             @click="changeStatus('20')">待确认(<i class="item-num">{{num1 + num5}}</i>)</div>
        <div class="zhuangtai"
             :class="{'zhuangtaiclick' : number==='30'}"
             @click="changeStatus('30')">待付款(<i class="item-num">{{num2}}</i>)</div>
        <div class="zhuangtai"
             :class="{'zhuangtaiclick' : number==='40'}"
             @click="changeStatus('40')">付款中(<i class="item-num">{{num3}}</i>)</div>
        <div class="zhuangtai"
             :class="{'zhuangtaiclick' : number==='50'}"
             @click="changeStatus('50')">已付款(<i class="item-num">{{num4}}</i>)</div>
      </div>
      <div>
        <el-form :inline="true"
                 :model="dataForm"
                 @keyup.enter.native="getDataList(1)"
                 @submit.native.prevent>
          <div class="search-row">
            <div class="search-conent">
              <el-form-item label="">
                <el-input v-model="dataForm.searchInput"
                          placeholder="商品名称/编码/对账单号"
                          style="width:250px"
                          clearable></el-input>
              </el-form-item>
            </div>
            <!-- <div class="search-conent">
              <el-form-item label="对账周期："
                            prop="equipmentType">
                <el-date-picker v-model="dataForm.dateValue"
                                type="daterange"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                style="width:240px;">
                </el-date-picker>
              </el-form-item>
            </div> -->
            <div class="search-but">
              <el-button @click="getDataList(1)"
                         style="width:90px"
                         type="primary">查询</el-button>
              <el-button style="margin-right:10px;width:90px;border-color:#1492FF;color:#1492FF;"
                         @click="reset()">重置</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <el-table :data="dataList"
                border
                @selection-change="selectionChangeHandle"
                :key="1">
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column type="index"
                         width="50"
                         label="序号"></el-table-column>
        <el-table-column prop="accountBillNo"
                         header-align="center"
                         align="center"
                         label="对账单号"
                         width="190"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="arAmount"
                         header-align="center"
                         align="center"
                         label="应付金额"
                         width="190"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.arAmount > scope.row.paidAmount"
                 style="color:red">{{scope.row.arAmount}}</div>
            <div v-else
                 style="color:red">{{scope.row.arAmount}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="paidAmount"
                         header-align="center"
                         align="center"
                         label="已付金额"
                         width="190"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.arAmount > scope.row.paidAmount"
                 style="color:red">{{scope.row.paidAmount}}</div>
            <div v-else
                 style="color:red">{{scope.row.paidAmount}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         header-align="center"
                         align="center"
                         label="当前状态"
                         width="190"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.status === 20">待确认</div>
            <div v-if="scope.row.status === 30">待付款</div>
            <div v-if="scope.row.status === 31">待确认</div>
            <div v-if="scope.row.status === 40">付款中</div>
            <div v-if="scope.row.status === 50">已付款</div>
            <div v-if="scope.row.status === 60">已评价</div>
          </template>
        </el-table-column>
        <el-table-column prop="effectiveDate"
                         header-align="center"
                         align="center"
                         label="对账时间"
                         show-overflow-tooltip>
        </el-table-column>
        <el-table-column fixed="right"
                         header-align="center"
                         align="center"
                         width="110"
                         label="操作">
          <template slot-scope="scope">
            <el-button type="text"
                       size="small"
                       style="color:blue"
                       @click="openDetailHandle(scope.row.billId)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="totalPage"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index';
export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.reconciliationSettlement')
        }
      ],
      activeStatus: '1',
      pageSize: 10,
      selectList: [],
      dataForm: {
        dateValue: '',
        status: '',
        accountBillNo: '',
        searchInput: ''
      },
      statusList: [
        // 状态(20 待确认、30 待付款、40 付款中、50 已付款)
        { code: '20', value: '待确认' },
        { code: '30', value: '待付款' },
        { code: '40', value: '付款中' },
        { code: '50', value: '已付款' }
      ],
      dataList: [],
      number: 'all',
      activeTag: '',
      num1: 0, // 待确认个数
      num2: 0, // 待付款
      num3: 0, // 付款中
      num4: 0, // 已付款
      num5: 0,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    handleTabClick (currentActive) {
      this.choosedParam = currentActive
      if (currentActive === 'all') {
        this.dataForm.status = ''
      } else if (currentActive === '20') {
        this.dataForm.status = '20,31'
      } else {
        this.dataForm.status = currentActive
      }
      this.getDataList()
      // this.getCountList()
    },
    // 获取数量
    getCountList () {
      var num1Flag = false
      var num2Flag = false
      var num3Flag = false
      var num4Flag = false
      var num5Flag = false
      let params = {
        searchInput: this.dataForm.searchInput,
        statusArr: this.dataForm.status,
        accountBillNo: this.dataForm.accountBillNo,
        startDate: this.dataForm.dateValue ? this.dataForm.dateValue[0] : '',
        endDate: this.dataForm.dateValue ? this.dataForm.dateValue[1] : '',
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
      }
      this.$http.post(`/front/order/lclb/accountbill/getStatusCount`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            // 状态(20 待确认、30 待付款、40 付款中、50 已付款)
            res.data.forEach((item) => {
              if (item.status === 20) {
                this.num1 = item.cnt
                num1Flag = true
              } else if (item.status === 30) {
                this.num2 = item.cnt
                num2Flag = true
              } else if (item.status === 40) {
                this.num3 = item.cnt
                num3Flag = true
              } else if (item.status === 50) {
                this.num4 = item.cnt
                num4Flag = true
              } else if (item.status === 31) {
                this.num5 = item.cnt
                num5Flag = true
              }
            })
            if (!num1Flag) {
              this.num1 = 0
            }
            if (!num2Flag) {
              this.num2 = 0
            }
            if (!num3Flag) {
              this.num3 = 0
            }
            if (!num4Flag) {
              this.num4 = 0
            }
            if (!num5Flag) {
              this.num5 = 0
            }
          }
        })
    },
    changeStatus (currentActive) {
      this.number = currentActive
      if (currentActive === 'all') {
        this.dataForm.status = ''
      } else if (currentActive === '20') {
        this.dataForm.status = '20,31'
      } else {
        this.dataForm.status = currentActive
      }
      this.getDataList()
      // this.getCountList()
    },
    // 多选
    selectionChangeHandle (list) {
      this.selectList = list
    },
    routerHandle (routerName) {
      this.$router.push(routerName)
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      this.getDataList(page)
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        this.changePageTo(this.jumpTargetPage)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList (currentPage = this.currentPage) {
      let params = {
        searchInput: this.dataForm.searchInput,
        page: currentPage,
        limit: this.pageSize,
        statusArr: this.dataForm.status,
        accountBillNo: this.dataForm.accountBillNo,
        startDate: this.dataForm.dateValue ? this.dataForm.dateValue[0] : '',
        endDate: this.dataForm.dateValue ? this.dataForm.dateValue[1] : '',
        companyId: localStorage.getItem('defaultCompanyId') !== '' ? localStorage.getItem('defaultCompanyId') : null
      }
      this.$http.post(`/front/order/lclb/accountbill/listByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataList = res.data.data || []
            this.totalPage = Math.ceil(res.data.count / 10)
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.setPageTo(currentPage)
        })
        .catch(() => {
          this.dataList = []
        })
    },
    setPageTo (page) {
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    // 清空form
    reset () {
      this.dataForm = {
        dateValue: '',
        status: '',
        accountBillNo: ''
      }
      this.getDataList(1)
    },
    // 跳转详情
    openDetailHandle (id) {
      this.$router.push({ name: 'spareStatementDetail', query: { id: id } })
    }
  },
  mounted () {
    this.getDataList()
    this.getCountList()
  },
  beforeRouteEnter (to, from, next) {
    if (!localStorage.getItem('defaultCompanyId')) {
      next({
        name: 'home'
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
.main {
  padding: 20px;
  padding-top: 5px;
  width: 1190px;
  margin: 0 auto;
  background: #fff;
  /* border-top: 1px solid #ccc; */
}
.conent {
  width: 970px;
  padding: 20px 20px;
}
.search-row {
  display: flex;
}
.search-conent {
  min-width: 250px;
  margin-right: 20px;
}
.search-but {
  width: 100%;
  min-width: 200px;
  text-align: left;
  margin-left: 15px;
}
.opt-row {
  width: 100%;
  display: flex;
  text-align: right;
  margin-bottom: 20px;
}
.opt-right {
  width: 300px;
}
.opt-left {
  width: 100%;
  text-align: left;
}
.info-but {
  background: #ffffff;
  width: 96px;
  height: 40px;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #1d65a8;
  letter-spacing: 0;
  border: none;
  cursor: pointer;
  user-select: none;
  border: 1px solid #1d65a8;
  margin-right: 10px;
}
.info-but:hover {
  background: #1d65a8;
  color: #ffffff;
}
.info-but-new {
  background: #1d65a8;
  color: #ffffff;
}
.but-file {
  background-color: #ffffff;
  border: none;
}
.demand-desc {
  width: 100%;
  cursor: pointer;
}
.tip {
  max-width: 500px;
  word-wrap: break-word;
  word-break: break-all;
}
.red {
  color: red;
}
.detail-icon {
  cursor: pointer;
}
.detail-icon:hover {
  color: #1d65a8;
}
.tooltip-content {
  width: 60px;
  text-align: center;
  border-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.short-content {
  max-height: 69px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.exportL {
  margin-top: 25px;
  height: 60px;
  padding-left: 20px;
}
.exportL span {
  float: left;
  margin-right: 20px;
  color: #333;
  cursor: pointer;
  font-size: 16px;
}
.exportL .qh {
  color: #1d65a8;
  border-bottom: 2px solid #1d65a8;
}
.item-num {
  color: #f00;
  font-style: normal;
}
.zhuangtai {
  width: 90px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-weight: bold;
  color: rgb(56, 50, 50);
  float: left;
  cursor: pointer;
}
.zhuangtaiclick {
  border-bottom: 3px solid #1492ff;
  color: #1492ff;
}
.tablist {
  width: 100%;
  height: 40px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: white;
  margin-bottom: 10px;
}
</style>
